import {Color, Widget} from '@esgi/main/features/admins/dashboard';
import {useMemo} from 'react';

export function useFilteredColorItems({excludedColor}: {excludedColor: Color | null}) {
	return useMemo(() => Widget.colorItems.filter(({value}) => value !== excludedColor), [excludedColor]);
}
